import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Signup = () => {
    const navigate = useNavigate()

    const [email, setEmail] = useState()
    const [password, setPasswordl] = useState()
    const [cpassword, setCpassword] = useState()


    const postData = async (e) => {

        e.preventDefault();

        const res = await fetch('/signup', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email, password, cpassword })
        });

        const data = await res.json()

        if (!email || !password || !cpassword) {
            toast.warning('Plese fill the email and passaword filed ', {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        if (password !== cpassword) {
            toast.warning('password not matched', {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        if (res.status === 200) {
            if (password === cpassword) {
                toast.success('User Signup  successfull', {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                setEmail('')
                setPasswordl('')
                setCpassword('')

            }
        }
    }

    return (
        <div className='conatiner-fluid signup_container'>
            <div className='row'>

                <div className='col-md-6 col-sm-10 login_form_left' >
                    <div style={{ fontSize: '1.2rem', color: 'darkgreen' }}>Sign up</div>
                    <div className="mb-3 mt-3">
                        <label for="uname" className="form-label">Email</label>
                        <input type="text" className="form-control"
                            onChange={(e) => setEmail(e.target.value)}
                            id="uname" placeholder="Enter Email" name="uname" required />

                    </div>
                    <div className="mb-3">
                        <label for="pwd" className="form-label">Password</label>
                        <input type="password"
                            onChange={(e) => setPasswordl(e.target.value)}
                            className="form-control" id="pwd" placeholder="Enter password" name="pswd" required />

                    </div>
                    <div className="mb-3">
                        <label for="pwd" className="form-label">Confirm Password</label>
                        <input type="password"
                            onChange={(e) => setCpassword(e.target.value)}
                            className="form-control" id="pwd" placeholder="confirm Enter password" name="pswd" required />

                    </div>
                    <div className='mb-3'>
                        <button style={{ width: '220px' }}
                            onClick={postData}
                            type="submit" className="btn btn-primary">Sign In</button>
                        <ToastContainer />
                    </div>
                    <p>Already register : <NavLink to='/login'>
                        please Login
                    </NavLink></p>
                </div>

                <div className='col-md-6 col-sm-10 login_form_right'>
                    <img src='../images/signup.jpg' className='img-fluid' />
                </div>

            </div>
        </div>
    )
}

export default Signup;